import { useTranslation } from 'react-i18next'
import { FlowLayout, OptionGrid, Select } from '@/ds'
import { useAppNavigate } from '@/lib/query-params'
import { useCheckinFlow } from '../CheckinFlow'
import { backLabelKey, neighbours, progressFor, stepPath } from '../flow'

const LEGACY = 'v2.legacy.stepper'

/** El PMS puede repetir una misma opción; el id es la identidad real del documento. */
function uniqueDocumentTypes<T extends { id: string }>(types: T[]) {
  return types.filter((type, index) => types.findIndex((candidate) => candidate.id === type.id) === index)
}

/** Paso previo al escaneo: MobbScan recibe un tipo de documento ya confirmado por la persona. */
export function DocumentoTipo() {
  const { t } = useTranslation()
  const { go } = useAppNavigate()
  const { stay, draft, update, updateGuest } = useCheckinFlow()
  const { prev, next } = neighbours('2c', stay, draft.persona, draft.method, draft.entry)
  const countries = stay.registration.catalogs.documentCountries
  const country = countries.find((item) => item.id === draft.docCountryId) ?? countries[0]
  const documentTypes = uniqueDocumentTypes(country?.documentTypes ?? [])
  const documentType = documentTypes.find((item) => item.id === draft.documentTypeId) ?? documentTypes[0]

  const chooseCountry = (id: string) => {
    const selected = countries.find((item) => item.id === id)
    update({ docCountryId: id, documentTypeId: selected?.documentTypes.find((item) => item.scanType !== 'qr')?.id ?? selected?.documentTypes[0]?.id ?? '' })
    updateGuest({ countryId: id, provinceId: '', municipalityId: '' })
  }

  return (
    <FlowLayout
      progress={{ ...progressFor('2c', stay, draft.persona, draft.method, draft.entry), backLabel: t(backLabelKey(prev)), onBack: () => go(stepPath(prev)) }}
      title={t('v2.checkin.documento.prepararTitulo')}
      intro={t('v2.checkin.documento.prepararIntro')}
      primary={{ label: t('v2.checkin.continuar'), onClick: () => go(stepPath(next)), disabled: !documentType }}
    >
      {countries.length > 1 && (
        <Select
          label={t('v2.checkin.documento.pais')}
          options={countries.map((item) => ({ id: item.id, label: item.name }))}
          value={country?.id ?? ''}
          onChange={chooseCountry}
          searchable
          searchLabel={t('v2.ds.select.buscarPais')}
          searchPlaceholder={t('v2.ds.select.buscarPais')}
          noResultsText={t('v2.ds.select.sinResultados')}
        />
      )}
      {country && (
        <OptionGrid
          label={t(`${LEGACY}.collectDataForm.fields.identifierTypeId`)}
          size="chip"
          options={documentTypes.map((item) => ({ id: item.id, label: item.scanType === 'qr' ? t(`${LEGACY}.collectDataForm.documentTypes.miDniQr`) : item.label }))}
          value={documentType?.id ?? null}
          onChange={(id) => update({ documentTypeId: id })}
        />
      )}
    </FlowLayout>
  )
}
